import { PopoverMenuItem } from 'components/Header/DesktopMenu/PopoverMenuItem';

interface DesktopMenuProps {
  menuItems: MenuItemType[];
}

export type MenuItemType = {
  label: string;
  url: string;
  subMenu?: MenuItemType[];
};

export function DesktopMenu(props: DesktopMenuProps) {
  const { menuItems } = props;

  return (
    <div role="navigation" aria-label="Hauptmenü">
      {menuItems.map((menuItem) => (
        <PopoverMenuItem
          key={menuItem.label}
          label={menuItem.label}
          url={menuItem.url}
          submenuItems={menuItem.subMenu}
        />
      ))}
    </div>
  );
}
